/**
 * @desc 根据来源单号获取库存事务ID
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/inPlan/getFulfilmentInfoBySourceNo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
